// extracted by mini-css-extract-plugin
export var compactFilters = "_eh-4";
export var detailImage = "_eh-1";
export var dropdownContainer = "_eh-2";
export var imageContainer = "_eh-0";
export var selectedCard = "_eh-3";